import { useLocation, useNavigate } from "react-router"
import type { Assignment, Submission } from "../../../proto/qf/types_pb"
import { getStatusByUser, isApproved, isGroupSubmission, isValidSubmissionForAssignment } from "../../Helpers"
import { useAppState } from "../../overmind"
import ProgressIndicator from "../ProgressIndicator"
import SubmissionTypeIcon from "../student/SubmissionTypeIcon"
import type { NavLink } from "./NavBarLink"
import NavBarLink from "./NavBarLink"


const NavBarLabs = () => {
    const state = useAppState()
    const navigate = useNavigate()
    const location = useLocation()

    const assignments = state.assignments[state.activeCourse.toString()] ?? []

    const submissionIcon = (submission: Submission) => {
        return (
            <>
                <SubmissionTypeIcon solo={!isGroupSubmission(submission)} />
                {isApproved(getStatusByUser(submission, state.self.ID)) && <i className="fas fa-check ml-2" />}
            </>
        )
    }

    const isHighlighted = (submission: Submission, assignment: Assignment): boolean => {
        // The submission should be highlighted if:
        // - the assignment ID is equal to the selected assignment ID
        //  AND ONE OF THE FOLLOWING:
        // - the location contains `group-lab` and the submission is a group submission
        // - the location contains `lab` and the submission is not a group submission
        if (state.selectedAssignmentID === assignment.ID) {
            const groupPath = location.pathname.includes("group-lab")
            if (groupPath && isGroupSubmission(submission)) {
                return true
            } else if (!groupPath && !isGroupSubmission(submission)) {
                return true
            }
        }
        return false
    }

    return (
        <>
            <div className={location.pathname.endsWith("/submission-guide") ? "bg-base-100" : ""}>
                <NavBarLink link={{
                    text: "Submission Guide",
                    to: `/course/${state.activeCourse}/submission-guide`
                }} />
            </div>
            {assignments.map(assignment => {
                const submissions = state.submissions.ForAssignment(assignment)
                if (!submissions) {
                    return null
                }
                return submissions.map(submission => {
                    if (!isValidSubmissionForAssignment(submission, assignment)) {
                        return null
                    }
                    const link: NavLink = {
                        text: assignment.name,
                        to: `/course/${state.activeCourse}/${isGroupSubmission(submission) ? "group-lab" : "lab"}/${assignment.ID}`,
                        jsx: submissionIcon(submission)
                    }
                    const highlighted = isHighlighted(submission, assignment)
                    return (
                        <div
                            className={`relative ${highlighted ? "bg-base-100" : ""}`}
                            key={submission.ID.toString()}
                            onClick={() => { navigate(link.to) }}
                            role="button"
                            aria-hidden="true"
                        >
                            <NavBarLink link={link} />
                            <ProgressIndicator courseID={state.activeCourse.toString()} submission={submission} />
                        </div>
                    )
                })
            })}
        </>
    )
}

export default NavBarLabs
